// src/plugins/sales-forecast/components/ResetControl.tsx
import React from "react";
import { useSystemTheme } from "../hooks/useSystemTheme";
import "../../sales-forecast/styles/theme.css";

interface ResetControlProps {
  onReset: () => void;
  cloneTitle?: string; // ✨ NEW: optional, to show what we're resetting to
}

export const ResetControl: React.FC<ResetControlProps> = ({ onReset, cloneTitle }) => {
  const theme = useSystemTheme();

  // Pull system theme colors from CSS variables
  const textColor = "var(--text-color)";
  const accentColor = "var(--accent-color)";
  const borderColor = "var(--border-color)";

  const defaultBg = "var(--input-bg)";

  // ✨ Dynamic button text based on whether we have a clone
  const buttonText = cloneTitle 
    ? `Reset` 
    : "Reset";

  return (
    <button
      onClick={onReset}
      className={`theme-${theme} transition-all duration-200 rounded-lg font-medium`}
      style={{
        backgroundColor: defaultBg,
        color: textColor,
        border: `1px solid ${borderColor}`,
        padding: "0.5rem 1rem",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.15)",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = accentColor;
        e.currentTarget.style.color = "#fff";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = defaultBg;
        e.currentTarget.style.color = textColor;
      }}
    >
      {buttonText}
    </button>
  );
};
